module.exports = __webpack_public_path__ + "3be68f272e41691d.svg";